import { render, staticRenderFns } from "./MessageItemAttachment.vue?vue&type=template&id=bcfb7d48&"
import script from "./MessageItemAttachment.vue?vue&type=script&lang=ts&"
export * from "./MessageItemAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports